import LocationOffIcon from '@mui/icons-material/LocationOff';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { CircularProgress } from '@mui/material';
import React, { useMemo, useRef, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Map from '../../../components/common/Map';
import credentials from '../../../components/common/credential';
import DataGridGenerico from '../../../components/dataGrid/DataGridGenerico';
import { generateColumnsDefaultConfiguration } from '../../../components/dataGrid/columnHelpers';
import { EncodeToBase64 } from '../../../helpers/tools';
import { PopoverModal } from '../../../components/popoverModal/PopoverModal';
import { getDateToString } from '../../../utils/convert';
import { CustomDialog } from '../../../components/customDialog/CustomDialog';

const mapURL = `https://maps.googleapis.com/maps/api/js?v=3.exp&key=${credentials.mapsKey}`;

export default function AuditoriaDataGrid({ rows }) {
    const [auditoria, setAuditoria] = useState(null);
    const path = '/auditoriaAdmin';

    const [openDlgMapa, setOpenDlgMapa] = useState(false);

    const [latitud, setLatitud] = useState('');
    const [longitud, setLongitud] = useState('');
    const [nombreUsuario, setNombreUsuario] = useState('');

    const initialColumns = [
        {
            headerName: '',
            field: 'action',
            flex: 0.02,
            renderCell: (params) => {
                let auditoriaId = EncodeToBase64(params.row.id.toString());
                let geolocacion = params.row.longitud && params.row.latitud;
                return (
                    <PopoverModal>
                        <div className='popover-modal-content'>
                            <Link to={`/auditoriaDetalle/${auditoriaId}`} >
                                <div
                                    className='item-option clickable-option'
                                >
                                    <VisibilityIcon className='edit-icon' />
                                    <span className='toggle-action'>Ver</span>
                                </div>
                            </Link>
                            <div
                                aria-hidden="true"
                                onClick={() => handlePrint(params.row)}
                                className='item-option clickable-option'
                            >
                                <PictureAsPdfIcon className='edit-icon' />
                                <span className='toggle-action'>Imprimir</span>
                            </div>

                            {geolocacion &&
                                <div
                                    aria-hidden="true"
                                    onClick={() => handleUbicacion(params.row)}
                                    className='item-option clickable-option'
                                >
                                    <LocationOnIcon className='edit-icon' />
                                    <span className='toggle-action'>Ver ubicación</span>
                                </div>
                            }

                            {!geolocacion &&
                                <div
                                    className='item-option'
                                >
                                    <LocationOffIcon className='edit-icon' />
                                    <span className='toggle-action'>Sin ubicación</span>
                                </div>
                            }

                        </div>
                    </PopoverModal>
                );
            }
        },
        {
            field: 'usuario',
            headerName: 'Usuario',
            valueGetter: (_, row) => {
                const usuario = `${row.usuario} ( ${row.idUsuario} )`;
                return usuario;
            }
        },
        { field: 'ipUsuario', headerName: 'IP' },
        { field: 'fecha', type: 'date', headerName: 'Fecha', time: true },
        { field: 'accion', headerName: 'Acción' },
        { field: 'descripcionAccion', headerName: 'Descripción', valueGetter: (value) => value.toString().toUpperCase() },
        { field: 'idClave', headerName: 'Clave' },
    ];

    const columns = useMemo(() => generateColumnsDefaultConfiguration(initialColumns), [rows]);

    const txtFiltro = useRef(null);

    const navigate = useNavigate();

    const handleView = (auditoria) => {
        navigate('/auditoriaDetalle/' + EncodeToBase64(auditoria.id.toString()));
        //navigate(path + '/' + auditoria.id, { state: { auditoria: auditoria, edit: false } });
    }


    const handlePrint = (auditoria) => {
        window.open('/auditoriaPrint/' + EncodeToBase64(auditoria.id.toString()));
    }

    const handleUbicacion = (auditoria) => {
        setOpenDlgMapa(true);
        setLongitud(auditoria.longitud);
        setLatitud(auditoria.latitud);
        setNombreUsuario(auditoria.usuario.toString());
    }

    const handleCloseDlgMapa = () => {
        setOpenDlgMapa(false);
    }

    return (
        <>
            <DataGridGenerico
                columns={columns}
                fileNameExport='Terminos'
                rows={rows}
                totalCount={rows.length}
                toolbar={false}
            />
            <CustomDialog
                maxWidth="lg"
                fullWidth={true}
                open={openDlgMapa}
                title={'Ubicación'}
                onCancel={handleCloseDlgMapa}
            >
                <Map
                    googleMapURL={mapURL}
                    containerElement={<div style={{ height: '400px' }} />}
                    mapElement={<div style={{ height: '100%' }} />}
                    loadingElement={<CircularProgress disableShrink />}
                    latitud={latitud}
                    longitud={longitud}
                    usuario={nombreUsuario}
                />
            </CustomDialog>
        </>
    );
}

